import React, { useEffect, useState } from "react";
import styles from "./ViewJobDetails.module.scss";
import Form from "../../Form";
import Loading from "../../../Common/Loading";
import ConditionalRender from "../../../reusable-components/ConditionalRender";
import { Button, Modal, message } from "antd";
import TNStepperForm from "../../TNStepperForm";
import { StepperTypeAttributes } from "../../../enums/StepperTypeAttributes";
import tickIcon from "../../../assets/images/current-active-step.svg";
import UncheckIcon from "../../../assets/images/uncheck-icon.svg";
import BackButton from "../../../assets/images/back-button.svg";
import { useLocation } from "react-router-dom";
import CreateJobServices from "../../../services/createJob.services";
import ViewJobLead from "./ViewJobLead";
import ViewMaterialAndTruck from "./ViewMaterialAndTruck";
import ViewQuote from "./ViewQuote";
import ViewCustomerApproval from "./ViewCustomerApproval";
import ViewInternalApproval from "./ViewInternalApproval";
import RolesServices from "../../../services/roles.services";
import SalesPersonCustomerApproval from "./SalesPersonCustomerApproval";
import { ApprovalStatus } from "./ViewInternalApproval/constants";
import { useHistory } from "react-router-dom";
import { appRoutes } from "../../../constants/appRoutes";
import { jobStatus } from "../CreateJobView/constants";
import ViewNoData from "./ViewNoData";
import { NoActionOnSubmissionStates, ViewableStates } from "./constants";
import greenTickIcon from "../../../assets/images/accept-icon.svg";
import { CommonButtonTexts } from "../../../enums/ButtonAttributesEnums";

const ViewJobDetails = () => {
  const navigate = useHistory();
  const { ADD_TRUCKING_MATERIAL, VIEW_TRUCKING_MATERIAL, ADD_JOB } = appRoutes;
  const userDetails = localStorage.getItem("userDetails");
  const userDetailsJson = JSON.parse(userDetails);
  const userRoleInfo = userDetailsJson?.["userRoleInfo"];
  const userId = userDetailsJson?.["id"];
  const { FetchUserRoleDetails } = RolesServices();
  const { ApproveInternalDocuments, FetchSelectedJob, BypassL2Approval } =
    CreateJobServices();
  const {
    mutateAsync: approveInternalDocuments,
    isPending: isApprovalPending,
  } = ApproveInternalDocuments();
  const { data: roleDetails, refetch: refetchRoles } =
    FetchUserRoleDetails(userRoleInfo);
  const { mutateAsync: byPassL2Approval } = BypassL2Approval();
  const isInternalApprover = roleDetails?.some((role) =>
    role.otherData?.some((panel) =>
      panel.multiPannel?.some(
        (subPanel) =>
          subPanel.title === "Trucking & Material" &&
          subPanel.selectedOptions?.includes("Internal Approval")
      )
    )
  );
  const location = useLocation();
  const pathLeadId = location.pathname.split("/")[3];
  const {
    data: viewJobData,
    isLoading,
    refetch: refecthJobDetails,
  } = FetchSelectedJob(pathLeadId);
  const [jobDetails, setJobDetails] = useState(viewJobData);
  const [currentStep, setCurrentStep] = useState(1);
  const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);
  const handleCurrentStep = (step) => setCurrentStep(step);
  const handleOpenWarningModal = () => setIsWarningModalOpen(true);
  const handleCloseWarningModal = () => setIsWarningModalOpen(false);
  const handlePrevStep = () => {
    currentStep > 1 ? setCurrentStep(currentStep - 1) : setCurrentStep(1);
  };
  const handleNextStep = () => {
    currentStep < 5 ? setCurrentStep(currentStep + 1) : setCurrentStep(5);
  };
  const handleNavigate = () => {
    navigate.push(ADD_JOB + window.location?.hash);
  };

  const showWarning =
    viewJobData?.stageId === jobStatus?.l1ApprovalPending ||
    viewJobData?.stageId === jobStatus?.l2approvalPending;
  const approvalPending = !!viewJobData
    ? !!viewJobData?.approvalDocuments
      ? Object.values(viewJobData?.approvalDocuments)?.find(
          (item) =>
            item?.status === jobStatus.pendingStatus ||
            item?.status === jobStatus.l1Approved
        )
      : false
    : false;

  const [internalApprovalPayload, setInternalApprovalPayload] = useState(null);

  const [isBypassApprovalModalOpen, setBypassApprovalModalOpen] =
    useState(false);
  const [isL1ApprovedSuccessModalOpen, setL1ApprovedSuccessModalOpen] =
    useState(false);
  const [isSubmitLoading, setSubmitLoadingStatus] = useState(false);
  const handleSalesPersonApproval = async () => {
    setSubmitLoadingStatus(true);
    if (
      !isInternalApprover ||
      NoActionOnSubmissionStates.includes(jobDetails?.stageId)
    ) {
      setSubmitLoadingStatus(false);
      navigate.push(ADD_JOB + window.location?.hash);
      return;
    }
    const hasPending = !!jobDetails?.cashOrCreditSale 
      ? false
      : Object.entries(internalApprovalPayload).some(
          ([section, info]) => info.status === ApprovalStatus.pending
        );
    if (hasPending) {
      message.error("Please approve/reject all sections");
      setSubmitLoadingStatus(false);
      return;
    }
    if (!hasPending) {
      const payload = {
        ...(!!jobDetails?.cashOrCreditSale ? {} : internalApprovalPayload),
        cashOrCreditSale: !!jobDetails?.cashOrCreditSale,
        reviewedBy: userId,
        reviewedAt: new Date().toLocaleDateString(),
        leadId: pathLeadId,
      };
      const data = await approveInternalDocuments(payload);
      if (data?.message === "success") {
        message.success("Successfully submitted for internal Approval!");
        if (data?.data?.stageId === jobStatus.l2approvalPending) {
          setL1ApprovedSuccessModalOpen(true);
        } else {
          navigate.push(ADD_JOB + window.location?.hash);
        }
      } else {
        message.error("Error while approving the documents. Please try again");
      }
    }
    setSubmitLoadingStatus(false);
  };

  const isAllReviewedByUser = () => {
    if (jobDetails?.stageId === jobStatus.l2approvalPending) {
      return Object.values(jobDetails?.approvalDocuments)?.every((section) => {
        const approvedReview = section?.review?.find(
          (r) => r?.status === ApprovalStatus.approved
        );
        return approvedReview?.reviewedBy === userId;
      });
    }
    return false;
  };

  const handleByPassL2Approval = async () => {
    const payload = {
      leadId: pathLeadId,
      reviewedBy: userId,
      reviewedAt: new Date().toLocaleDateString(),
    };
    const data = await byPassL2Approval(payload);
    if (data.message === "success") {
      setBypassApprovalModalOpen(true);
      message.success("Successfully submitted for internal Approval!");
      navigate.push(ADD_JOB + window.location?.hash);
    } else {
      message.error("Error while approving the documents. Please try again");
    }
  };

  const currentStage = (currentStep) => {
    switch (currentStep) {
      case 1:
        return (
          <ConditionalRender
            visible={ViewableStates.STEP_1.includes(jobDetails?.stageId)}
            fallback={<ViewNoData />}
          >
            <ViewJobLead jobLeadData={jobDetails} />
          </ConditionalRender>
        );
      case 2:
        return (
          <ConditionalRender
            visible={ViewableStates.STEP_2.includes(jobDetails?.stageId)}
            fallback={<ViewNoData />}
          >
            <ViewMaterialAndTruck jobLeadData={jobDetails} />
          </ConditionalRender>
        );
      case 3:
        return (
          <ConditionalRender
            visible={ViewableStates.STEP_3.includes(jobDetails?.stageId)}
            fallback={<ViewNoData />}
          >
            <ViewQuote jobLeadData={jobDetails} />
          </ConditionalRender>
        );
      case 4:
        return (
          <ConditionalRender
            visible={ViewableStates.STEP_4.includes(jobDetails?.stageId)}
            fallback={<ViewNoData />}
          >
            <ViewCustomerApproval jobId={pathLeadId} />
          </ConditionalRender>
        );
      case 5:
        return isInternalApprover && !!!jobDetails?.isBlocked ? (
          <ConditionalRender
            visible={ViewableStates.STEP_5.includes(jobDetails?.stageId)}
            fallback={<ViewNoData />}
          >
            <SalesPersonCustomerApproval
              jobDetails={jobDetails}
              setInternalApprovalPayload={setInternalApprovalPayload}
              userId={userId}
            />
          </ConditionalRender>
        ) : (
          <ConditionalRender
            visible={ViewableStates.STEP_5.includes(jobDetails?.stageId)}
            fallback={<ViewNoData />}
          >
            <ViewInternalApproval jobLead={jobDetails} />
          </ConditionalRender>
        );
      default:
        return <ViewJobLead jobLeadData={jobDetails} />;
    }
  };

  useEffect(() => {
    async function fetchData() {
      const jobDetails = await refecthJobDetails(pathLeadId);
      setJobDetails(jobDetails?.data);
    }
    refetchRoles();
    fetchData();
  }, [pathLeadId]);

  const steps = [
    {
      title: "Job Lead",
      activeIcon: tickIcon,
      inactiveIcon: UncheckIcon,
    },
    {
      title: "Material & Truck Details",
      activeIcon: tickIcon,
      inactiveIcon: UncheckIcon,
    },
    {
      title: "Build Quote",
      activeIcon: tickIcon,
      inactiveIcon: UncheckIcon,
    },
    {
      title: "Customer Approval",
      activeIcon: tickIcon,
      inactiveIcon: UncheckIcon,
    },
    {
      title: "Internal Approval",
      activeIcon: tickIcon,
      inactiveIcon: UncheckIcon,
    },
  ];
  const currentFormStep = currentStage(currentStep);
  return (
    <>
      <Modal
        visible={isWarningModalOpen}
        onCancel={handleCloseWarningModal}
        title="Confirm Cancel"
        okText="Confirm"
        onOk={() => {
          handleCloseWarningModal();
          handleNavigate();
        }}
      >
        <p className={styles.warningModalWrapper}>
          If you cancel the edit, all modifications you have made will be lost.
        </p>
      </Modal>
      <Modal
        visible={isBypassApprovalModalOpen}
        onCancel={() => {
          setBypassApprovalModalOpen(false);
        }}
        title="Confirm L2 Approval"
        okText="Confirm"
        onOk={handleByPassL2Approval}
        className={styles.BypassModal}
      >
        <p className={styles.warningModalWrapper}>
          You are approving the internal request without a second-level
          approval. Please confirm to continue.
        </p>
      </Modal>
      <Modal
        visible={isL1ApprovedSuccessModalOpen}
        onCancel={() => {
          setL1ApprovedSuccessModalOpen(false);
          navigate.push(`/app/trucking-material${window.location?.hash}`);
        }}
        footer={false}
        className={styles.L1ApprovedModal}
      >
        <div className={styles.L1ApprovedContainer}>
          <img src={greenTickIcon} alt="L1 APPROVED" width={"10%"} />
          <h2>L1 Approved</h2>
          <p>Do you wish to Bypass L2 Approval?</p>
          <Button
            type="default"
            size="large"
            className={styles.ButtonSave}
            onClick={() => {
              setBypassApprovalModalOpen(true);
              setL1ApprovedSuccessModalOpen(false);
            }}
          >
            Bypass L2 Approval
          </Button>
        </div>
      </Modal>
      <Form>
        {({ watch, control: { handleSubmit } }) => {
          const formValues = watch();

          return (
            <>
              <Loading enableLoading={isLoading} />
              <div className={styles.CreateJobButtonContainer}>
                <div
                  className={styles.ButtonsContainer}
                  onClick={
                    isInternalApprover &&
                    currentStep === 5 &&
                    showWarning &&
                    approvalPending
                      ? handleOpenWarningModal
                      : handleNavigate
                  }
                >
                  <img
                    src={BackButton}
                    alt="back-button"
                    className={styles.backButtonStyle}
                  />
                  <h1 className={styles.NewJobHeading}>View Job Details</h1>
                </div>
                <div className={styles.ButtonsContainer}>
                  <ConditionalRender
                    visible={
                      currentStep === 5
                      && isInternalApprover
                      && !!!jobDetails.isBlocked
                    }
                  >
                    <Button
                      type="primary"
                      size="large"
                      className={styles.ButtonSave}
                      onClick={() => setBypassApprovalModalOpen(true)}
                      danger
                      disabled={
                        viewJobData?.stageId !== jobStatus.l2approvalPending
                      }
                    >
                      Bypass L2 Approval
                    </Button>
                  </ConditionalRender>
                  <ConditionalRender visible={currentStep > 1}>
                    <Button
                      type="default"
                      size="large"
                      className={styles.ButtonSave}
                      onClick={handlePrevStep}
                    >
                      Previous
                    </Button>
                  </ConditionalRender>
                  <ConditionalRender visible={currentStep < 5}>
                    <Button
                      type="default"
                      size="large"
                      className={styles.ButtonSave}
                      onClick={handleNextStep}
                    >
                      Next
                    </Button>
                  </ConditionalRender>
                  <ConditionalRender
                    visible={
                      currentStep === 5
                      && !isAllReviewedByUser()
                      && !!!jobDetails.isBlocked
                      && ViewableStates.STEP_5.includes(jobDetails?.stageId)
                    }
                  >
                    <Button
                      type="primary"
                      size="large"
                      className={styles.ButtonSave}
                      onClick={handleSalesPersonApproval}
                      loading={isSubmitLoading}
                    >
                      {
                        isInternalApprover
                        ? !!jobDetails?.cashOrCreditSale 
                            ? CommonButtonTexts.APPROVE
                            : CommonButtonTexts.SUBMIT
                        : CommonButtonTexts.EXIT
                      }
                    </Button>
                  </ConditionalRender>
                </div>
              </div>
              <div className={styles.FormContainer}>
                <TNStepperForm
                  type={StepperTypeAttributes.NAVIGATION_STEPS}
                  currentStep={currentStep}
                  handleCurrentStep={handleCurrentStep}
                  currentFormStep={currentFormStep}
                  steps={steps}
                  showPricingDetailsView={false}
                />
              </div>
            </>
          );
        }}
      </Form>
    </>
  );
};
export default ViewJobDetails;
